import OfferProductTypeSelector from 'modules/funnels/funnel/components/offer-settings/offer-product-type-selector'
import {
  DigitalOfferEditInterface,
  DigitalOfferViewInterface,
} from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/digital-offer-interface'
import {
  PhysicalOfferEditInterface,
  PhysicalOfferViewInterface,
} from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/physical-offer-interface'
import { OfferTypeEnum } from 'modules/funnels/funnel/enums/offer-type-enum'
import React, { FC, useEffect, useState } from 'react'
import { SectionMessage } from 'shared/components/section-message'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface ProductWrapperProps {
  children: (type: OfferTypeEnum) => JSX.Element
  digitalProduct:
    | DigitalOfferViewInterface['digitalProduct']
    | DigitalOfferEditInterface['digitalProduct']
  product: PhysicalOfferViewInterface['product'] | PhysicalOfferEditInterface['product']
}

const ProductWrapper: FC<ProductWrapperProps> = ({ children, digitalProduct, product }) => {
  const { t } = useLocoTranslation()

  const [type, setType] = useState<OfferTypeEnum>()
  useEffect(() => {
    if (digitalProduct) {
      setType(OfferTypeEnum.digital)
    } else if (product) {
      setType(OfferTypeEnum.physical)
    } else {
      setType(undefined)
    }
  }, [digitalProduct, product])

  return (
    <div className="flex flex-col px-4 lg:px-0">
      <OfferProductTypeSelector
        selected={type}
        onChange={type => {
          setType(type)
        }}
      />
      {type ? (
        <div className="bg-[rgb(var(--brand-primary-subtle))] flex w-full grow flex-col gap-5 px-4 py-7">
          {children(type)}
        </div>
      ) : (
        <SectionMessage>
          {t('dashboard.funnel.configuration.offer.no_product_selected')}
        </SectionMessage>
      )}
    </div>
  )
}

export default ProductWrapper
